export const iconFontAwesomeSecurityIdCardClip = (
	<i className="fa-solid fa-id-card-clip"></i>
);
